import TextareaMobile, { TextareaProps as VKTextareaProps } from '@vkontakte/vkui/dist/components/Textarea/Textarea';
import TextareaDesktop from './TextareaDesktop';
import { getPlatformComponent } from '../utils/getPlatformComponent';

export interface TextareaProps extends VKTextareaProps {}

export default getPlatformComponent<TextareaProps>({ mobile: TextareaMobile as any, desktop: TextareaDesktop });
